import PropTypes from "prop-types";

/**
 * Ordinal rank indicator.
 */
export const RankIndicator = ({ rank = 0 }) => {
    return (
        <span
            className="rankIndicator"
            aria-hidden={true}
            data-testid="rankIndicator"
        >
            {rank}
        </span>
    );
};

RankIndicator.propTypes = {
    rank: PropTypes.number.isRequired,
};

export default RankIndicator;
